import React from 'react';
import {
	StyledHeader,
	StyledContainer,
	StyledContainerHeader,
	StyledContainerTitle,
	StyledContainerContent,
	StyledFlex,
	ReasonSmallText,
	ReasonBigText,
	ReasonsFlex,
	SubCardText,
} from './style';
import CardBox from '../../../components/Campanhas/CardBox/index';

import { ReactComponent as HappyFace } from '../../../icons/Campanhas/Happy.svg';
import { ReactComponent as Medal } from '../../../icons/Campanhas/Medal.svg';
import { ReactComponent as Snap } from '../../../icons/Campanhas/Snap.svg';
import { ReactComponent as Car } from '../../../icons/Campanhas/Car.svg';
import { ReactComponent as Fire } from '../../../icons/Campanhas/Fire.svg';

const reasons = [
	{
		icon: <Fire />,
		description: 'Audiência qualificada e mídia 100% direcionada',
		bigText: '+ 30 milhões',
		smallText: 'de visitas por mês',
	},
	{
		icon: <Car height="50px" />,
		description: 'Top of mind entre os classificados',
		bigText: '+ 360 mil',
		smallText: 'usuários por dia',
	},
	{
		icon: <HappyFace />,
		description: 'Site favorito para compra e venda',
		bigText: '10 milhões',
		smallText: 'de usuários únicos por mês',
	},
	{
		icon: <Medal />,
		description: 'São mais de 20 anos de história',
		bigText: '+ 320 milhões',
		smallText: 'pagáveis por mês',
	},
];

const ReasonCard = ({
	icon,
	description,
	bigText,
	smallText,
}) => (
	<StyledFlex flexDirection="column" minWidth="200px">
		<StyledFlex flexDirection="column" margin="0 0 32px 0">
			{icon}
			<ReasonSmallText minHeight="44px">{description}</ReasonSmallText>
		</StyledFlex>
		<StyledFlex flexDirection="column">
			<ReasonBigText>{bigText}</ReasonBigText>
			<ReasonSmallText marginTop="4px">{smallText}</ReasonSmallText>
		</StyledFlex>
	</StyledFlex>
);

const WebmotorsMedia = () => (
	<div style={{ padding: '35px', paddingLeft: '64px' }}>
		<StyledHeader>Mídias Webmotors</StyledHeader>
		<StyledContainer>
			<StyledContainerHeader>
				<Snap /> <span>Para você anunciar sua loja ou seus veículos no site da Webmotors</span>
			</StyledContainerHeader>
			<StyledContainerContent>
				<StyledContainerTitle>Por que anunciar na Webmotors?</StyledContainerTitle>
				<ReasonsFlex>
					{
						reasons.map(reason => (
							<ReasonCard
								icon={reason.icon}
								description={reason.description}
								bigText={reason.bigText}
								smallText={reason.smallText}
							/>
						))
					}
				</ReasonsFlex>
			</StyledContainerContent>
		</StyledContainer>
		<div className="d-flex justify-content-between flex-column flex-md-row">
			<CardBox
				title="Formatos de anúncio"
				textButton="Baixar mídia kit"
				linkButton="https://static-campanhas.webmotors.com.br/downloads/M%C3%ADdia%20Kit%20-%20M%C3%ADdias%20na%20Webmotors.pdf"
				targetButton="_blank"
				classButton="btn btn-gearbox text-white"
				classComponent="mr-md-4 mb-4"
				boxShadow="0px 2px 2px #9C9C9C24"
			>
				<SubCardText>
					Conheça todos os formatos disponíveis para você anunciar na Webmotors.
				</SubCardText>
			</CardBox>
			<CardBox
				title="Se interessou?"
				classComponent="ml-md-4 mb-4"
				boxShadow="0px 2px 2px #9C9C9C24"
			>
				<SubCardText>
					Fale com o seu gerente de relacionamento e solicite um orçamento.
				</SubCardText>
			</CardBox>
		</div>
	</div>
);

export default WebmotorsMedia;
